<template>
  <a :id="buttonID" href="javascript:void(0)" class="btn" :title="hoverTitle" :class="cssClass" @click="onClick($event)">
    <span class="align-middle button-icon" :class="icon"></span>
    {{ title }}
    <span id="loading-indicator" v-show="isBusy">
      <img src="../assets/tail-spin-white.svg" width="22" alt="">
    </span>
  </a>
</template>

<script>
export default {
  props: {
    icon: {
      type: String,
      required: true
    },
    isBusy: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ''
    },
    hoverTitle: {
      type: String,
      default: ''
    },
    btnClass: {
      type: [String, Object, Array],
      default: 'btn-primary'
    },
    enabled: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    onClick(ev) {
      if (!this.isBusy && this.enabled) {
        if(ev && ev.target && ev.target.blur) {
          ev.target.blur();
        } 
        this.$emit('click', ev);
      }
    }
  },
  computed: {
    buttonID() {
      return 'btn' + this._uid;
    },
    cssClass() {
      const self = this;
      return [
        { 'disabled': this.isBusy || this.enabled === false },
        { 'loading': this.isBusy },
        self.btnClass
      ];
    },
  }
};
</script>

<style lang="scss" scoped>
.btn {
  text-decoration: none;
  position: relative;

  &.loading {
    padding-right: 36px;

    #loading-indicator {
      position: absolute;
      right: 6px;
      top: 4px;
    }
  }
}

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}

.button-icon {
  background-size: 18px;
  width: 18px;
  height: 18px;
  display: inline-block;

  &.arrow-repeat-white {
    background-image: url('~@/assets/arrow-repeat-white.svg');
  }

  &.find-and-replace-white {
    background-image: url('~@/assets/find-and-replace-white.svg');
  }

  &.send {
    background-image: url('~@/assets/send.svg');
  }
}
</style>